import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-4 flex flex-col gap-8"
}
const _hoisted_2 = { class: "w-full flex justify-between" }
const _hoisted_3 = { class: "w-[80%]" }
const _hoisted_4 = { class: "font-[800]" }
const _hoisted_5 = { class: "flex justify-center items-center gap-2" }
const _hoisted_6 = { class: "bg-h-info-100 flex justify-center items-center p-1 px-4 rounded-xl text-h-primary-500" }
const _hoisted_7 = { class: "w-full lg:w-[25%] min-w-[200px] gap-2 flex flex-row-reverse lg:flex-row justify-end lg:justify-start items-center" }
const _hoisted_8 = { class: "w-[20px] h-[40px] flex items-center justify-center" }
const _hoisted_9 = { class: "w-[180px]" }
const _hoisted_10 = { class: "line-clamp-2" }
const _hoisted_11 = { class: "w-full flex flex-col gap-8" }
const _hoisted_12 = { class: "h-[40px] w-full bg-h-neutral-200 flex rounded-md overflow-auto overflow-x-hidden" }
const _hoisted_13 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_14 = {
  key: 1,
  class: "w-full h-[40px] flex items-center p-4"
}
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = { class: "p-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_EmptyData = _resolveComponent("EmptyData")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.questions.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex flex-col w-full bg-white p-4 pb-8 rounded-b-md border-b-4 border-h-primary-500 py-4 min-h-[100px] gap-8 shadow-md",
              key: i
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(question?.prompt), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Questão: ", en: "Question: " })), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", { pt: "Aberta", en: "Open" })), 1)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.items, (item, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-col gap-4 lg:flex-row",
                  key: j
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (item.itemId === question.correctItemId)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            name: "hi-solid-check-circle",
                            class: "text-[#74B543]"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(item.answerText), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (item.choseTimes && item.choseTimes > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(`flex justify-end p-4 items-center h-[40px] ${_ctx.getBackground(
                  item?.itemId,
                  question.correctItemId
                )} rounded-l-md`),
                            style: _normalizeStyle(`width:${item.percentage}%`)
                          }, [
                            (item.percentage > 17)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(item.choseTimes) + " (" + _toDisplayString(item.percentage) + "%) ", 1))
                              : _createCommentVNode("", true)
                          ], 6))
                        : _createCommentVNode("", true),
                      (item.choseTimes === 0 || item.percentage < 17)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("p", _hoisted_15, _toDisplayString(item.percentage) + "%", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_EmptyData, {
        data: _ctx.questions.length == 0,
        title: `${_ctx.$t('labels.generic', {
          pt: 'Dados não encontrados',
          en: 'titleEN',
        })}`,
        label: `${_ctx.$t('labels.generic', {
          pt: 'Os dados gerados pelas respostas dos quizzes ficarão aqui.',
          en: 'titleEN',
        })}`,
        image: 'waiting_object.svg',
        imgSize: "h-40"
      }, null, 8, ["data", "title", "label", "image"])
    ])
  ]))
}